import { calculatePaymentWarrantyDate } from 'components/features/binding/contract-detail/transaction-details/form';
import dayjs from 'dayjs';
import { Dayjs } from 'dayjs';
import {
  ContractAdjustmentPayloadDtoAdjustmentTypeEnum,
  ContractResponseDto,
  SubmissionResponseDto,
} from 'libs/pinnacle-sdk';
import { getLocalDateForMidnightUTC } from 'utils';

export interface TransactionDetailsFormValues {
  transactionDate: Dayjs;
  adjustmentType?: ContractAdjustmentPayloadDtoAdjustmentTypeEnum;
  documentNumber?: string;
  pinnacleReferenceNumber?: string;
  insured?: string;
  brokerReference?: string;
  underwritingYear?: number;
  inceptionDate: Dayjs;
  expiryDate: Dayjs;
  premiumPaymentWarranty: number;
  paymentWarrantyDate?: Dayjs;
  oldPinReferenceNumber?: string;
  underwritingComments?: string;
}

export const DEFAULT_PREMIUM_PAYMENT_WARRANTY = 120;

export const getTransactionDetailInitialValues = (
  submission: SubmissionResponseDto,
  contract?: ContractResponseDto
): TransactionDetailsFormValues => {
  const paymentWarrantyDate = calculatePaymentWarrantyDate(
    getLocalDateForMidnightUTC(submission.inceptionDate),
    contract?.premiumPaymentWarranty
      ? Number(contract?.premiumPaymentWarranty)
      : DEFAULT_PREMIUM_PAYMENT_WARRANTY
  );

  return {
    transactionDate: dayjs(),
    adjustmentType: undefined,
    documentNumber:
      contract?.pinnacleReferenceNumber +
      '-E' +
      ((contract?.adjustmentCount ?? 0) + 1),
    pinnacleReferenceNumber: contract?.pinnacleReferenceNumber,
    insured: submission.insured?.name,
    underwritingYear: contract?.binder?.underwritingYear,
    inceptionDate: getLocalDateForMidnightUTC(submission.inceptionDate),
    expiryDate: getLocalDateForMidnightUTC(submission.expiryDate ?? new Date()),
    brokerReference: contract?.brokerReference,
    premiumPaymentWarranty: contract?.premiumPaymentWarranty
      ? Number(contract?.premiumPaymentWarranty)
      : 120,
    paymentWarrantyDate,
    oldPinReferenceNumber: contract?.oldPinReferenceNumber,
    underwritingComments: undefined,
  };
};
